"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Status;

(function (Status) {
  Status["ENTERING"] = "ENTERING";
  Status["ENTERED"] = "ENTERED";
  Status["EXITING"] = "EXITING";
  Status["EXITED"] = "EXITED";
})(Status || (Status = {}));

var Collapsible =
/** @class */
function (_super) {
  __extends(Collapsible, _super);

  function Collapsible() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      status: Status.EXITED,
      height: null
    };

    _this.cx = function () {
      switch (_this.state.status) {
        case Status.ENTERING:
          return 'collapsing';

        case Status.ENTERED:
          return 'collapse show';

        case Status.EXITING:
          return 'collapsing';

        case Status.EXITED:
          return 'collapse';
      }
    };

    _this.elementRef = function (element) {
      if (element) {
        _this.element = element;
      }
    };

    _this.onEntering = function () {
      _this.setState({
        status: Status.ENTERING
      }, function () {
        _this.setState({
          height: _this.element.scrollHeight
        });
      });
    };

    _this.onEntered = function () {
      _this.setState({
        status: Status.ENTERED,
        height: _this.element.scrollHeight
      });
    };

    _this.onExiting = function () {
      _this.setState({
        status: Status.EXITING,
        height: 0
      });
    };

    _this.onExited = function () {
      _this.setState({
        status: Status.EXITED,
        height: null
      });
    };

    return _this;
  }

  Collapsible.prototype.componentWillReceiveProps = function (props) {
    var _this = this;

    if (props.show) {
      this.onEntering();
    } else {
      this.onExiting();
    }

    setTimeout(function () {
      if (props.show) {
        _this.onEntered();
      } else {
        _this.onExited();
      }
    }, 350);
  };

  Collapsible.prototype.render = function () {
    var height = this.state.height;
    var style = height === null ? {} : {
      height: height
    };
    return react_1.default.createElement("div", {
      className: this.cx(),
      ref: this.elementRef,
      style: style
    }, this.props.children);
  };

  return Collapsible;
}(react_1.Component);

exports.Collapsible = Collapsible;